import { render } from "./RContainer.vue?vue&type=template&id=af09a60c&scoped=true&lang=true"
import script from "./RContainer.vue?vue&type=script&lang=js"
export * from "./RContainer.vue?vue&type=script&lang=js"

import "./RContainer.vue?vue&type=style&index=0&id=af09a60c&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af09a60c"]])

export default __exports__